import { isDemo, exitDemo, resetDemoDbSafe } from '@/lib/demo/demoBannerHelpers';

// Amber ribbon shown across the top of every page while the tab is in demo
// mode. Reminds the viewer nothing is real, offers a data reset and an exit.
export function DemoBanner() {
  if (!isDemo()) return null;
  return (
    <div className="bg-amber-400 text-[#2C1810] text-xs font-bold flex items-center justify-center gap-3 px-3 py-1.5 flex-shrink-0">
      <span className="material-symbols-outlined text-base">science</span>
      DEMO MODE — fake data, everything stays in this tab, nothing is saved
      <button onClick={() => { resetDemoDbSafe(); window.location.reload(); }} className="underline underline-offset-2">
        Reset data
      </button>
      <button onClick={() => { exitDemo(); window.location.href = '/portal/login'; }} className="underline underline-offset-2">
        Exit demo
      </button>
    </div>
  );
}
